<template>
  <div class="wizard-console">
    <TransitionGroup name="fade" tag="div" class="wizard-console-list">
      <div v-for="(item, i) in timeline" :key="item.title" class="wizard-console-item">
        <div class="row align-items-center">
          <div class="col" :class="item.isError ? 'text-danger' : 'text-muted'">
            <component :is="item.icon" stroke-width="1" class="me-2"></component> {{ item.title }}
          </div>
          <div class="col-auto">
            <div class="status-slot">
              <IconX v-if="item.isError" stroke-width="1" class="text-danger"></IconX>
              <IconCheckbox
                v-else-if="i !== timeline.length - 1 || isDone"
                stroke-width="1"
                class="text-green"></IconCheckbox>
              <div v-else class="spinner-border" role="status"></div>
            </div>
          </div>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { IconCheckbox, IconX } from '@tabler/icons-vue';

export type ScanTimelineItem = {
  title: string;
  icon: any;
  isError?: boolean;
};

defineProps<{
  timeline: ScanTimelineItem[];
  isDone: boolean;
}>();
</script>

<style scoped>
.wizard-console {
  height: 100%;
  overflow-y: auto;
}

.wizard-console-list {
  display: flex;
  flex-direction: column-reverse;
}

.wizard-console-item {
  margin: 2.5px;
  border-radius: 3px;
  background-color: #fff;
  padding: 6px 12px;
  border-bottom: 1px solid #d3d3d3;
}

.fade-enter-active,
.fade-move {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(-12px);
}

.status-slot {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.status-slot .spinner-border {
  width: 18px;
  height: 18px;
  border-width: 1px;
}
</style>
